import { Dialog, Sheet } from "@gravity-ui/uikit";

import { FiltersContent } from "../FiltersContent";
import css from "./FiltersSheet.module.scss";

interface FiltersSheetProps {
  open: boolean;
  onClose: () => void;
}

export const FiltersSheet = ({ open, onClose }: FiltersSheetProps) => {
  return (
    <Sheet className={css.sheet} visible={open} onClose={onClose}>
      <Dialog.Body>
        <FiltersContent onClose={onClose} />
      </Dialog.Body>
    </Sheet>
  );
};
